import React from "react";
import { useUserContext } from "../../contexts";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";

export const Header = React.memo(() => {
	const { user } = useUserContext();
	const { instance } = useMsal();

	const handleLogout = async () => {
		instance.logoutRedirect().catch((error) => console.log(error));
	};

	return (
		<>
			<div className="ch-show-lg">
				<div className="flex justify-between ch-border-bottom w-full py-6 px-12">
					<div className="flex gap-6">
						<img
							src="images/svg/cornerstone.svg"
							width="48"
							height="48"
							alt="Cornerstone Health"
						/>
						<div className="ch-title">Cornerstone Admin</div>
					</div>
					<div className="flex items-center">
						<div className="ch-username pr-6">{user?.name}</div>
						<AuthenticatedTemplate>
							<button
								className="ch-button ch-button-primary"
								type="button"
								onClick={handleLogout}
							>
								Logout
							</button>
						</AuthenticatedTemplate>
					</div>
				</div>
			</div>

			<div className="ch-show-md">
				<div className="flex justify-between ch-border-bottom w-full py-4 px-8">
					<div className="flex gap-4">
						<img
							src="images/svg/cornerstone.svg"
							width="48"
							height="48"
							alt="Cornerstone Health"
						/>
						<div className="ch-title">Cornerstone Admin</div>
					</div>
					<div className="flex items-center gap-4">
						<div className="ch-username">{user?.name}</div>
						<AuthenticatedTemplate>
							<button
								className="ch-button ch-button-primary"
								type="button"
								onClick={handleLogout}
							>
								Logout
							</button>
						</AuthenticatedTemplate>
					</div>
				</div>
			</div>
		</>
	);
});
